import { colors, fontSizes } from "@/app/constants/styles";
import { StyleSheet } from "react-native";

export const confirmBoxStyles = StyleSheet.create({
  container: {
    backgroundColor: colors.maroon,
    borderRadius: 8,
    paddingVertical: 30,
    paddingHorizontal: 15,
  },
  buttonRow: {
    justifyContent: "flex-end",
    marginTop: 15,
  },
  buttonContainer: {
    justifyContent: "space-between",
    flexDirection: "row",
  },
  confirmOrderHeader: {
    fontSize: fontSizes.x20,
    fontFamily: "HelveticaNeue-Medium",
    color: colors.white,
    textAlign: "center",
    marginBottom: 10,
  },
  confirmOrderContainer: {
    width: "55%",
  },
  confirmOrderText: {
    fontSize: fontSizes.x10,
    fontFamily: "HelveticaNeue",
    color: colors.white,
    textAlign: "center",
    marginBottom: 15,
  },
  editOrderContainer: {
    width: "40%",
  },
  editOrderButton: {
    alignItems: "center",
    height: 50,
    borderRadius: 8,
    borderColor: colors.white,
    borderWidth: 1,
    justifyContent: "center",
  },
  editOrder: {
    fontSize: fontSizes.x12,
    fontFamily: "HelveticaNeue",
    color: colors.white,
  },
});

export const processingStyles = StyleSheet.create({
  container: {
    backgroundColor: colors.maroon,
    borderRadius: 8,
    paddingVertical: 30,
    paddingHorizontal: 15,
    alignItems: "center",
  },
  header: {
    fontSize: fontSizes.x20,
    fontFamily: "HelveticaNeue-Medium",
    color: colors.white,
    textAlign: "center",
    marginTop: 15,
  },
  subtext: {
    fontSize: fontSizes.x10,
    fontFamily: "HelveticaNeue",
    color: colors.white,
    opacity: 0.8,
    textAlign: "center",
    marginTop: 8,
  },
});

export const confirmOrderButtonStyles = StyleSheet.create({
  container: {
    paddingBottom: 5,
  },
  button: {
    backgroundColor: colors.albaikRed,
    alignItems: "center",
    height: 50,
    borderRadius: 8,
    justifyContent: "space-between",
    paddingHorizontal: 10,
    flexDirection: "row",
  },
  noTotal: {
    justifyContent: "center",
  },
  disabledButton: {
    opacity: 0.5,
  },
  totalContainer: {
    flexDirection: "column",
    alignItems: "flex-end",
  },
  totalText: {
    fontSize: fontSizes.x8,
    color: colors.white,
  },
  buttonText: {
    fontSize: fontSizes.x12,
    fontFamily: "HelveticaNeue-Medium",
    color: colors.white,
  },
});
